// THIS IS GLOBAL REACT COMPONENT FROM ECOSYSTEM54.
// IF YOU WANT TO CHANGE THIS FILE, PLEASE CONTACT THE MAIN FRONTEND DEVELOPER ON THE ECOSYSTEM54
// UPDATED 2024.01.24 //Format YYYY|MM|DD

import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Button, Popconfirm } from 'antd';
import Icon from '@mdi/react';
import BaseIcon from '../../_ui/BaseIcon/BaseIcon';
import BaseButton from '../../_ui/BaseButton/BaseButton';

const ButtonWithPopConfirmAntDesign54origins = memo(({
  className,
  disabled,
  type,
  pathForMdi,
  sizeMdi = 1,
  label,
  onClick,
  iconClassName,
  size,
  popConfirmTitle,
  popConfirmPlacement = 'top',
  popConfirmColor,
}) => (
  <Popconfirm
    placement={popConfirmPlacement}
    title={popConfirmTitle}
    onConfirm={onClick}
    okText="Yes"
    cancelText="No"
    color={popConfirmColor}
  >
    <BaseButton
      type={type}
      className={className}
      size={size}
      disabled={disabled}
      icon={pathForMdi && (
        <BaseIcon
          className={iconClassName}
          path={pathForMdi}
          size={sizeMdi}
        />
      )}
    >
      {label}
    </BaseButton>
  </Popconfirm>
));

ButtonWithPopConfirmAntDesign54origins.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
  pathForMdi: PropTypes.string,
  popConfirmColor: PropTypes.string,
  popConfirmPlacement: PropTypes.string,
  popConfirmTitle: PropTypes.string,
  size: PropTypes.number,
  sizeMdi: PropTypes.number,
  type: PropTypes.string,
  label: PropTypes.string,
};

export default ButtonWithPopConfirmAntDesign54origins;
